import type { FC, ReactNode } from "react";
import React, { memo } from "react";
import type { DisclaimerType } from "../../../hooks/useDisclaimers";
import styles from "./Disclaimers.module.scss";
import { CarConfigLabel } from "../../../utils/labelUtils";

const Disclaimer: FC<{ disclaimer: DisclaimerType }> = ({ disclaimer }) => {
    let dateLabel: ReactNode;
    if (disclaimer.from && disclaimer.until) {
        dateLabel = (
            <CarConfigLabel
                label="carConfigPromoFromUntilDate"
                params={{ from: disclaimer.from, until: disclaimer.until }}
            />
        );
    } else if (disclaimer.from && !disclaimer.until) {
        dateLabel = <CarConfigLabel label="carConfigPromoFromDate" params={{ from: disclaimer.from }} />;
    } else if (!disclaimer.from && disclaimer.until) {
        dateLabel = <CarConfigLabel label="carConfigPromoUntilDate" params={{ until: disclaimer.until }} />;
    }

    return (
        <div id={disclaimer.id} className={styles.disclaimer} data-cpdqm="ignore">
            {disclaimer.index && <div className={styles["disclaimer-number"]}>{disclaimer.index}</div>}
            {disclaimer.name && <div className={styles["disclaimer-title"]}>{disclaimer.name}</div>}
            {disclaimer.disclaimer && <div dangerouslySetInnerHTML={{ __html: disclaimer.disclaimer }} />}
            {dateLabel && <div>{dateLabel}</div>}
        </div>
    );
};

export default memo(Disclaimer);
